var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMapPinLine = function SvgIconMapPinLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 9.75a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 22.75a1 1 0 1 1 0-2h3.994a25 25 0 0 1-1.749-1.813C5.563 16.715 3.5 13.485 3.5 9.75a8.5 8.5 0 1 1 17 0c0 3.735-2.063 6.965-3.995 9.187a25 25 0 0 1-1.75 1.813h3.995a1 1 0 1 1 0 2zM7.404 5.154A6.5 6.5 0 0 1 18.5 9.75c0 3.015-1.687 5.785-3.505 7.875A23.4 23.4 0 0 1 12 20.495q-.228-.183-.524-.433a23.4 23.4 0 0 1-2.471-2.437C7.187 15.535 5.5 12.765 5.5 9.75a6.5 6.5 0 0 1 1.904-4.596"
  }))));
};
export default SvgIconMapPinLine;